import React from 'react'
import { injectIntl } from 'react-intl'
import platformConfig from '../../config/config'

const PageTitle = ({ intl, title, name }) => {
  const defaultName = platformConfig.name
  const rawMessage = intl.messages?.[title] || ''
  const containsNamePlaceholder = rawMessage.includes('{name}')

  const displayName = name || defaultName
  const baseTitle = containsNamePlaceholder
    ? intl.formatMessage({ id: title }, { name: displayName })
    : intl.formatMessage({ id: title })

  return (
    <div className="flex space-x-4 justify-center items-center mt-8 mb-8">
      <h1 className="py-3 px-6 rounded-full shadow-xxl font-semibold text-secondary text-xl text-center">
        {baseTitle}
      </h1>
    </div>
  )
}

export default injectIntl(PageTitle)
